import { ProductType } from '@inter-ikea-storageone/range';
import { Entity } from '@inter-ikea-core/core';
import { HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';

const removeOrganizersFromSelectedEntity = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return null;
  }
  const accessories = HierarchyUtils.descendants(selectedEntity).filter((entity: Entity) =>
    coreApi.entities.isOneOfProductTypes(entity, [
      ProductType.PAX_SKUBB_STORAGE_CASES,
      ProductType.PAX_SKUBB_SHOE_BOXES,
      ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
      ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
      ProductType.PAX_SKUBB_STORAGE_BOXES,
      ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
      ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
      ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
      ProductType.PAX_SKUBB_HANGING_STORAGE
    ])
  );
  if (accessories.length > 0) {
    removeProducts(accessories, coreApi, products);
  }
};

export default removeOrganizersFromSelectedEntity;
